var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreece01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 282.65 282.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .greece-1 {\n        fill: #fff;\n      }\n\n      .greece-2 {\n        fill: #0d5eaf;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M157.18,0v157.18H.88c-.58-5.21-.88-10.5-.88-15.85,0-16.52,2.83-32.37,8.04-47.11,3.93-11.12,9.22-21.61,15.66-31.26,10.37-15.53,23.73-28.89,39.26-39.26,9.64-6.44,20.13-11.73,31.25-15.66C108.95,2.83,124.81,0,141.33,0h15.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-1",
    d: "M157.18,62.96v31.26h-62.97v62.96h-31.25v-62.96H8.04c3.93-11.12,9.22-21.61,15.66-31.26h39.26V23.7c9.64-6.44,20.13-11.73,31.25-15.66v54.92h62.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M230.21,31.44h-73.03V.88c27.5,3.07,52.61,14.03,73.03,30.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-1",
    d: "M258.9,62.89h-101.72v-31.45h73.03c11.07,8.97,20.76,19.57,28.7,31.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M274.65,94.33h-117.47v-31.44h101.72c6.49,9.7,11.8,20.24,15.75,31.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-1",
    d: "M281.81,125.77h-124.63v-31.44h117.47c3.53,10.01,5.96,20.54,7.15,31.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M282.65,141.33c0,5.37-.3,10.67-.88,15.89h-124.59v-31.45h124.63c.56,5.11.85,10.3.85,15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-1",
    d: "M281.77,157.22c-1.22,10.9-3.68,21.43-7.24,31.44H8.12c-3.56-10.01-6.02-20.54-7.24-31.44h280.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M274.53,188.66c-3.98,11.2-9.33,21.75-15.85,31.44H23.98c-6.53-9.69-11.88-20.24-15.85-31.44h266.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-1",
    d: "M258.68,220.1c-7.99,11.88-17.74,22.49-28.88,31.44H52.85c-11.14-8.95-20.89-19.56-28.88-31.44h234.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "greece-2",
    d: "M229.8,251.54c-24.21,19.47-54.98,31.11-88.47,31.11s-64.26-11.65-88.47-31.11h176.94Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece01);
export default __webpack_public_path__ + "static/media/Greece-01.b2fb7043a11a735054fabe6cfa915dac.svg";
export { ForwardRef as ReactComponent };